// extracted by mini-css-extract-plugin
export default {"form":"ListFiltersForm_form__p4O3j"};